import React, {Component} from 'react';
import {withApplicationContext} from "../../../contexts/ApplicationContext"
import {
    SectionContainer,
    SectionTitle,
    SectionBody,
    ContactItem,
    ContactItemBody,
    ContactItemIcon, ContactItemText
} from "./style.jsx";
import {Container} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class ContactUs extends Component {
    render() {
        const {applicationContext} = this.props;
        return (
            <SectionContainer bg={"gray"}  id={"section-contact"}>
                <Container>
                    <SectionTitle><div className={"wrapper"}>{applicationContext.translator("Contact")}</div></SectionTitle>
                    <SectionBody>
                        <ContactItem>
                            <ContactItemIcon><div><FontAwesomeIcon icon={"envelope"} /></div></ContactItemIcon>
                            <ContactItemBody>
                                <ContactItemText>
                                    <h3>{applicationContext.translator("E-Mail")}</h3>
                                    <a href={"mailto:support@myroulette.tv"}>support@myroulette.tv</a>
                                    <small>{applicationContext.translator("Support average e-mail response time < 1 working hour")}</small>
                                </ContactItemText>
                            </ContactItemBody>
                        </ContactItem>
                    </SectionBody>

                </Container>
            </SectionContainer>

        );
    }
}

export default withApplicationContext(ContactUs);